import React from 'react';
import { useBoardsUiStore } from '../../extensions/bundled/task-manager/boardsUiStore';
import './BoardSummary.css';

/** "● 8 done  ● 17 open  32 %" — the open board's progress at a glance
 *  (Boards Redesign card 3.3; no bar since the owner's 13.10.2026 call).
 *  `progress` = boardProgress(board).
 *  "done" and "open" are filters (owner, 13.10.2026): a click shows only those
 *  cards, a second click (or the filter bar's Clear) shows everything again. */
export default function BoardSummaryPill({ progress }) {
  const state = useBoardsUiStore((s) => s.filters.state);
  const setFilters = useBoardsUiStore((s) => s.setFilters);
  const { total = 0, done = 0, open = 0, pct = 0 } = progress || {};
  if (!total) return null;
  const stat = (key, count) => {
    const on = state === key;
    return (
      <button
        type="button"
        className={`task-board-summary-stat task-board-summary-stat--btn${on ? ' task-board-summary-stat--on' : ''}`}
        aria-pressed={on}
        aria-label={on ? `Showing ${key} tasks only — show all` : `Show ${key} tasks only`}
        onClick={() => setFilters({ state: on ? '' : key })}
      >
        <span className={`task-board-summary-dot task-board-summary-dot--${key}`} aria-hidden="true" />
        <span className="task-board-summary-num">{count}</span>
        <span className="task-board-summary-word"> {key}</span>
      </button>
    );
  };
  return (
    <div className="task-board-summary" aria-label={`${done} done, ${open} open, ${pct}% complete`} role="group">
      {stat('done', done)}
      {stat('open', open)}
      <span className="task-board-summary-pct">{pct}%</span>
    </div>
  );
}
